import Vue from 'vue'
import Vuex from 'vuex'
import vuexI18n from 'vuex-i18n'
import { VUEX_DEFAULT_CONFIG } from 'Config'
import commonStore from 'Store'
import Locales from 'Locales'
Vue.use(Vuex)

let storeConfig={
  ...commonStore,
  ...VUEX_DEFAULT_CONFIG
}
// 国际化配置
storeConfig.modules.i18n = vuexI18n.store

let store = new Vuex.Store(storeConfig)
Vue.use(vuexI18n.plugin, store)

for (let i in Locales) {
  Vue.i18n.add(i, Locales[i])
}
Vue.i18n.set('zh-CN')


export default store
